var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadOnlyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11911_46553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 7.99935C0.666748 7.99935 3.33341 2.66602 8.00008 2.66602C12.6667 2.66602 15.3334 7.99935 15.3334 7.99935C15.3334 7.99935 12.6667 13.3327 8.00008 13.3327C3.33341 13.3327 0.666748 7.99935 0.666748 7.99935Z",
    stroke: "#ABABAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.49805C8.82843 9.49805 9.5 8.82647 9.5 7.99805C9.5 7.16962 8.82843 6.49805 8 6.49805C7.17157 6.49805 6.5 7.16962 6.5 7.99805C6.5 8.82647 7.17157 9.49805 8 9.49805Z",
    fill: "#ABABAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11911_46553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadOnlyIcon);
export default __webpack_public_path__ + "static/media/readOnlyIcon.1b526a08f4abf5bcb52aa4f0341e2be0.svg";
export { ForwardRef as ReactComponent };